import { Box, Button, Flex, RiCloseFill } from "@itandi/itandi-bb-ui";
import clsx from "clsx";
import type React from "react";
import { ChatMessageArea } from "~/components/common/chat/messages/ChatMessageArea";
import { ChatPostArea } from "~/components/common/chat/post/ChatPostArea";
import type { Deal } from "~/models/Deal";
import type { Message, MessageSpeaker } from "~/models/Message";
import Styles from "./ChatPopContainer.module.scss";

type Props = {
	deal: Deal;
	handleClose: () => void;
	handleMutate: () => Promise<void>;
	handleTemporaryUnread: () => Promise<void>;
	isAdmin?: boolean;
	isOpen: boolean;
	isVendor?: boolean;
	messages: Message[];
	speaker: MessageSpeaker;
};

/**
 * 案件詳細でポップアップするチャット画面
 *
 * @param deal
 * @param speaker
 * @param isOpen
 * @param handleClose
 * @param isVendor
 * @param handleMutate
 * @param messages
 * @param handleTemporaryUnread
 * @param isAdmin
 * @constructor
 */
export const ChatPopContainer: React.FC<Props> = ({
	deal,
	speaker,
	isOpen,
	handleClose,
	isVendor = false,
	handleMutate,
	messages,
	handleTemporaryUnread,
	isAdmin = false
}: Props) => {
	const isDisabledTemporaryUnread =
		isAdmin ||
		deal.messageSummaryUnread?.unread ||
		deal.messageSummaryUnread?.displayUnread;
	return (
		<div
			className={clsx(Styles.ChatContainer, isOpen ? Styles.Show : Styles.Hide)}
		>
			<div className={Styles.Header}>
				<Flex gap="10rem">
					<Box marginTop="0.25rem">
						{isVendor ? "管理会社とチャット" : "施工会社とチャット"}
					</Box>
					{messages.length > 0 && (
						<Box marginLeft="1rem">
							<Button
								disabled={isDisabledTemporaryUnread}
								height="small"
								onClick={handleTemporaryUnread}
								variant="secondary"
							>
								未読ラベルをつける
							</Button>
						</Box>
					)}
				</Flex>
				<div className={Styles.CloseButtonWrapper}>
					<button
						className={Styles.CloseButton}
						onClick={handleClose}
						type="button"
					>
						<RiCloseFill className={Styles.CloseIcon} />
					</button>
				</div>
			</div>
			<ChatMessageArea
				deal={deal}
				handleMutate={handleMutate}
				isOpen={isOpen}
				messages={messages}
				speaker={speaker}
			/>
			<ChatPostArea
				deal={deal}
				handleMutate={handleMutate}
				isVendor={isVendor}
			/>
		</div>
	);
};
